import { useDispatch, useSelector } from "react-redux";
import { addTrackedDetails, updateTracker } from "../features/TrackerSlice";
import { FORM_TYPE_DELETE_IDENTITY, FORM_TYPE_OPT_OUT } from "../utils/constants";
const useTracker = () => {
  const dispatch = useDispatch();
  const controller_code = useSelector((state) => state.controllers.controller);
  const customer_scope = useSelector((state) => state.controller.scope);

  //TODO consept is below

  // function controllercode and customer scope tracker

  //identity managemnt
  //1. page identity_management
  //2.search value
  //3. create identity form

  // ID details page
  //initial - page,type,value
  //edit form - with values
  //active tabs
  //Tabs
  // if sub id aliases - create form

  const createIdentityTracker = ({ ...data }) => {
    dispatch(
      addTrackedDetails({
        form: { ...data },
        form_type: "create",
        modal_type: "create",
      })
    );
  };
  const updateIdentityTracker = ({ ...data }) => {
    dispatch(
      addTrackedDetails({
        form: { ...data },
        form_type: "update",
        modal_type: "update",
        controller_code: controller_code,
        customer_scope: customer_scope,
      })
    );
  };
  const createSubIdntyAliasesTracker = ({ ...data }) => {
    dispatch(
      addTrackedDetails({
        form: { ...data },
        form_type: "subIdAlias",
        modal_type: "subIdAlias",
        controller_code: controller_code,
        customer_scope: customer_scope,
      })
    );
  };
  const identitySearchTracker = ({ ...data }) => {
    dispatch(
      addTrackedDetails({
        identity_search: {
          ...data,
        },
      })
    );
  };
  const contentSearchTracker = (data) => {
    dispatch(
      addTrackedDetails({
        content_search: {
          value: data,
        },
      })
    );
  };
  const contentEnvnButtonTracker = (data) => {
    dispatch(
      addTrackedDetails({
        content_environment: data,
      })
    );
  };
  const activeTabTracker = ({ ...data }) => {
    dispatch(addTrackedDetails({ ...data }));
  };
  const controllerCodeTracker = (code, scope = "") => {
    dispatch(
      addTrackedDetails({
        controller_code: code,
        customer_scope: scope,
        form: {
          title: "",
          first_name: "",
          last_name: "",
          type: "",
          value: "",
          language: "",
          contact_email: "",
          recordType: "",
        },
        identity_search: {
          type: "",
          value: "",
        },
        form_type: "",
        modal_type: "",
      })
    );
  };
  const customerScopeTracker = (data) => {
    dispatch(
      addTrackedDetails({
        customer_scope: data,
        form: {
          title: "",
          first_name: "",
          last_name: "",
          type: "",
          value: "",
          language: "",
          contact_email: "",
          recordType: "",
        },
        identity_search: {
          type: "",
          value: "",
        },
        form_type: "",
        modal_type: "",
      })
    );
  };
  const pageTracker = () => {
    dispatch(addTrackedDetails({}));
  };
  const removeCreateIdentityTracker = () => {
    dispatch(
      addTrackedDetails({
        form: {
          title: "",
          first_name: "",
          last_name: "",
          type: "",
          value: "",
          language: "",
          contact_email: "",
          recordType: "",
        },
        form_type: "",
        modal_type: "",
      })
    );
  };

  const trackDeleteIdentity = (values) => {
    dispatch(
      addTrackedDetails({
        form_type: values?.snowId ? FORM_TYPE_DELETE_IDENTITY : "",
        delete_form: values?.snowId ? { snowId: values?.snowId?.trim() } : {},
      })
    );
  };

  const handleUpdateTracker = (obj) => {
    dispatch(updateTracker({ ...obj }));
  };

    const optOutTracker = (data ) => {
    dispatch(
      addTrackedDetails({
        form: data,
        form_type: FORM_TYPE_OPT_OUT,
        modal_type: FORM_TYPE_OPT_OUT,
      })
    );
  };

  return {
    createIdentityTracker,
    updateIdentityTracker,
    createSubIdntyAliasesTracker,
    identitySearchTracker,
    contentSearchTracker,
    activeTabTracker,
    pageTracker,
    removeCreateIdentityTracker,
    contentEnvnButtonTracker,
    controllerCodeTracker,
    customerScopeTracker,
    handleUpdateTracker,
    trackDeleteIdentity,
    optOutTracker
  };
};

export default useTracker;
